import {createAsyncThunk} from '@reduxjs/toolkit'

import {PAY} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {NavigationResult, LocationChangeHistoryParam, ThunkApi} from '../interfaces'

const PAYMENT_SUBSCRIPTION_SETTING = `${PAY}/member/settings/payment-subscription`

/**
 * 페이 멤버 정기/예약 설정 페이지로 이동
 */
const navigateToPaymentSubscriptionSetting = createAsyncThunk<
    NavigationResult,
    LocationChangeHistoryParam | void,
    ThunkApi
>('navigateTo/paymentSubscriptionSetting', (args) => {
    const {historyType = 'PUSH'} = args ?? {}

    changeBrowserLocation({url: PAYMENT_SUBSCRIPTION_SETTING, type: historyType})

    return Promise.resolve()
})

export default navigateToPaymentSubscriptionSetting
